module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popupBg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.pressCancel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest px-3"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 p-3"
  }, [_vm._v("\n            Payments\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 paymentRowsHolder"
  }, _vm._l((_vm.paymentsList), function(payment) {
    return _c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('span', {
      staticClass: "font-weight-600"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDateForList(payment.date)))]), _vm._v(" "), _c('span', {
      staticClass: "dark"
    }, [_vm._v(_vm._s(_vm.composePaymentDetailsRow(payment)))])]), _vm._v(" "), _c('span', {
      staticClass: "font-weight-600",
      class: {
        'color-3': payment.paymentDirection == 0,
        'color-6': payment.paymentDirection == 1
      }
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(payment.paymentDirection == 0 ? '' : '-'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatPrice(payment.value) + ' ' + payment.currency))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getPaymentDirections), function(paymentDirection) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('button', {
      staticClass: "btn widest w-100",
      class: {
        'opacity-30': _vm.payment.paymentDirection != null && _vm.payment.paymentDirection != paymentDirection.id,
        'action': paymentDirection.id == 1
      },
      on: {
        "click": function($event) {
          return _vm.showPaymentArea(paymentDirection.id)
        }
      }
    }, [_vm._v(_vm._s(paymentDirection.description))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-end mb-2 justify-content-end"
  }, [(_vm.reservation.status == '-5') ? _c('div', [_c('label', {
    staticClass: "mr-3"
  }, [_vm._v("\n                    Amount to refund\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600",
    class: {
      'color-6': _vm.refundTotalMissing < 0,
      'color-3': _vm.refundTotalMissing === 0
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.refundTotalMissing)) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.reservation.status != '-5') ? _c('div', [_c('label', {
    staticClass: "mr-3"
  }, [(_vm.totalDue >= 0) ? _c('span', [_vm._v("Due to Pay")]) : _vm._e(), _vm._v(" "), (_vm.totalDue < 0) ? _c('span', [_vm._v("Over Pay")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600",
    class: {
      'color-6': _vm.totalDue < 0
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalDue)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mx-3"
  }, [_vm._v("\n                    Total\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])]) : _vm._e()]), _vm._v(" "), (_vm.showPayArea) ? _c('div', {
    staticClass: "mt-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3 pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 d-flex flex-row align-items-center flex-wrap"
  }, [_c('payment-method-picker', {
    model: {
      value: (_vm.payment.type),
      callback: function($$v) {
        _vm.$set(_vm.payment, "type", $$v)
      },
      expression: "payment.type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex align-items-start"
  }, [_c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [(_vm.payment.paymentDirection == 1) ? _c('span', {
    staticClass: "color-6 fs-super mr-2"
  }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.payment.value),
      expression: "payment.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "fs-largest w-100 text-right bg-lighter glued-right overflow-auto",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "min": "0",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.payment.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "value", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border-light glued-left fs-largest py-2 px-2"
  }, [_vm._v("€")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 row mx-0 px-0 pb-3 border-top-light pt-3"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("\n                        Notes\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.description),
      expression: "payment.description"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 my-2 text-right"
  }, [_c('button', {
    staticClass: "btn tertiary wider",
    attrs: {
      "disabled": _vm.isSavingPayment
    },
    on: {
      "click": _vm.pressCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn primary wider ml-2",
    attrs: {
      "disabled": _vm.isSavingPayment
    },
    on: {
      "click": _vm.savePayment
    }
  }, [_vm._v("Done")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 d-flex flex-row justify-content-between"
  }, [_c('label', [_vm._v("Select payment method")]), _vm._v(" "), _c('label', [_vm._v("Amount")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3856502a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3856502a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/AddPayment.vue
// module id = 1945
// module chunks = 0